import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LibraryV2DataService } from 'src/app/core/services/library-v2/library-v2-data.service';
import { GoogleAnalyticsService } from 'src/app/core/services/google-analytics-service/google-analytics.service';
import { GlobalConstants } from 'src/app/common/constants/global.constant';
import { QrCodeService } from 'src/app/core/services/qr-input-service/qr-input.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-wildcat-lake-overview',
  templateUrl: './wildcat-lake-overview.component.html',
  styleUrls: ['./wildcat-lake-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WildcatLakeOverviewComponent implements OnInit {
  tileData: any;
  tileDetails: any;
  setFontIntelDisplayOne: boolean = false;
  activeIndex = 0;
  isreliabilityTile: boolean = false;
  isBatteryTile: boolean = false; 
  ptlVAHomePageText: any;
  homepageHeadline: string = 'assets/lang/[XX]/wcl/wcl-hompage-headline.gif';
  language: string = 'en-us';
  isScrollable: boolean = false;
  direction: string = '';
  setIntelDisplayOneFont: boolean = false;
  legalContent: any;
  legalText: string = '';
  legalVersion: string = '';
  legalTextFontClass: string = '';
  aiPcBundleUrl = environment.aiPcBundleUrl;
  showVirtualAssistant: boolean = false;
  showTileOverlay = false;
  isRTL: boolean = false;
  enusAndRtlArray = ['en-us','ar-sa','he']
  isperformanceTile: boolean = false; 

  @ViewChild('tileVideo') tileVideoRef!: ElementRef<HTMLVideoElement>;

  constructor(
    private modalService: NgbModal,
    private libraryService: LibraryV2DataService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private qrService: QrCodeService,
    private router: Router,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.ptlVAHomePageText = this.libraryService.getStaticText('tr_VAHomepageText');
    this.setFontIntelDisplayOne = this.qrService.setenusLang();
    this.language = this.qrService.qrInput.Language.toLowerCase();
    this.showVirtualAssistant = this.qrService?.showVirtualAssistant;
    this.homepageHeadline = this.homepageHeadline.replace(GlobalConstants.XX, this.language);
    this.tileData = this.libraryService.getTilesData(GlobalConstants.WILDCAT_LAKE_STD, GlobalConstants.DEFAULT_TYPE);
    if (!this.qrService.isAiPcBundleAvailable) {
      this.tileData = this.tileData.filter(tile =>
        tile.tileUrlName != GlobalConstants.AI_PC_BUNDLE
      );
    }
    if (this.language !== 'en-us') {
      this.tileData = this.tileData.filter(tile =>
        tile.tileUrlName != 'ai-demos'
      );
    }
    const batteryTile = this.tileData.find((element) => element.tileUrlName === 'battery');
    if (batteryTile?.tileDetails) {
      const language = this.qrService.qrInput.Language;
      batteryTile.tileDetails.detailBGUrl = batteryTile.tileDetails.detailBGUrl?.replace(GlobalConstants.XX, language);
      batteryTile.tileDetails.videoPosterUrl = batteryTile.tileDetails.videoPosterUrl?.replace(GlobalConstants.XX, GlobalConstants.EN_US_SMALL);
    }
    this.direction = this.qrService.direction;
    this.legalVersion = '&nbsp;' + this.qrService.qrInput?.LegalVersion;
    this.legalContent = this.libraryService.getHeaders('legal').tr_paragraph_array;
    this.legalContent = this.legalContent.map(ele => ele.replace('®', '<sup>®</sup>'));
    this.legalContent = this.legalContent.map(ele => ele.replace('[ZhCn Only Legal Text General]', ''));  // zh-cn legalcontent
    this.legalContent = this.legalContent.map(ele => ele.replace('[ZhCn Only Legal Text Point12]', ''));
    this.legalContent = this.legalContent.map(ele => ele.replace('[ZhCn Only Legal Text Point13]', ''));
    this.legalText = this.libraryService.getHeaders('legal').tr_specTitle;
    this.isRTL = this.qrService?.qrInput?.Language === "ar-sa" || this.qrService?.qrInput?.Language === "he";
    setTimeout(() => {
      const scrollContainer = document.querySelector('.content') as HTMLElement;
      if (scrollContainer) {
        this.isScrollable = scrollContainer.scrollHeight > scrollContainer.clientHeight;
      }
    }, 0);
  }

  openTileModal(item: any) {
    this.googleAnalyticsService.factTagAnalytics(item.tileUrlName, GlobalConstants.TILE);
    if (item.tileUrlName === 'ai-demos') {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
        this.router.navigate(['/specs/aidemos'])
      );
      return;
    }
    if (item.tileUrlName === GlobalConstants.AI_PC_BUNDLE) {
      this.googleAnalyticsService.factTagAnalytics(item.tileUrlName + '_' + this.aiPcBundleUrl, GlobalConstants.TILE);
      window.open(this.aiPcBundleUrl, '_blank');
      return;
    }
    if (!item.tileDetails) return;
    this.tileDetails = item.tileDetails;
    this.isreliabilityTile = item.tileUrlName === 'reliability';
    this.isBatteryTile = item.tileUrlName === 'battery';
    this.isperformanceTile = item.tileUrlName === 'performance';
    this.activeIndex = 0;
    this.showTileOverlay = true;
    this.cdr.markForCheck();
    setTimeout(() => {
      const vd = this.tileVideoRef?.nativeElement;
      if (vd) { vd.currentTime = 0; vd.play(); }
    }, 0);
  }

  closeModel() {
    this.showTileOverlay = false;
    const vd = this.tileVideoRef?.nativeElement;
    if (vd) vd.pause();
    this.cdr.markForCheck();
  }

  onIconClick(index: number) {
    this.activeIndex = index;
    this.cdr.markForCheck();
  }

  routeToTab(queryParam: string) {
    this.router.navigate([], { queryParams: { activeTab: queryParam } });
  }

  open(content: any) {
    this.modalService.open(content, {
      backdrop: 'static',
      centered: true,
      animation: false,
      windowClass: 'legal-text-popup'
    });
  }

  close() {
    this.modalService.dismissAll();
  }

}
